import { createSelector } from '@reduxjs/toolkit';
import type { CategoryListProps } from 'src/components/HotelRating/HotelRating';
import {
  getFromImmutableStateCompatible,
  getImmutableCompatible,
} from 'src/utils/immutableUtils';
import type { HotelRatingStore } from './types';

const _getRatings = (state) => getImmutableCompatible(state, 'ratings');
export const getRatings =
  getFromImmutableStateCompatible<HotelRatingStore>(_getRatings);

export const isRating = createSelector([_getRatings], (rating) =>
  Boolean(rating),
);

export const getRatingsScore = createSelector(
  getRatings,
  (rating) => rating && rating.score / 10,
);
export const getRatingsScoreDescription = createSelector(
  getRatings,
  (rating) => rating && rating.score_description,
);

export const getRatingsList = createSelector(
  getRatings,
  (rating) => rating && rating.category_list,
);
export const getCategoryList = createSelector(
  getRatingsList,
  (ratingList): CategoryListProps[] =>
    ratingList &&
    ratingList.map((item) => ({
      categoryName: item.category_name,
      score: item.score / 10,
    })),
);
export const getRatingsCount = createSelector(
  [getRatingsList],
  (list) => list && Math.max(...list.map((item) => item.count)),
);
export const getGoodToKnowList = createSelector(
  getRatings,
  (rating) => rating && rating.good_to_know_list,
);
export const getRatingsBadgeListHotel = createSelector(
  getRatings,
  (ratings) => {
    if (!ratings) {
      return null;
    }

    if (ratings.badge_list.length === 0) {
      return [];
    }

    return ratings.badge_list.filter(
      (item) => item.badge_type === 'hotel_type' && item.badge_data.score >= 80,
    );
  },
);

export const getRatingText = createSelector(
  getRatings,
  (rating) => rating && rating.text,
);
